<template>
    <div>
        <div class="page-title">
            <h4 v-if='this.admin'> {{$t('txt.admin')}}: {{this.admin.first_name}} {{this.admin.last_name}}</h4>
        </div>
        <div class="table-header edit-header">
            <div class="search-box">
                <router-link :to="`/admins/${this.admin.id}/edit`">
                    <button type="button" class="add-user edit-button">
                        <i class="far fa-edit"></i>
                        <span> {{$t('placeholder.editeaza')}} </span>
                    </button>
                </router-link>
            </div>
        </div>
        <form class="add-user-form">
            <div class="row">
                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <sequential-entrance fromTop delay="70">
                                <li v-for="input_field in input_fields.column_1" :key="input_field.id">
                                  <div class="view-info-wrapper">
                                    <div class="contact-design">
                                        <i :class="input_field.icon"></i>
                                        <span> {{input_field.labelName}} </span>
                                    </div>
                                    <p> {{input_field.inputValue}} </p>
                                  </div>
                                </li>
                            </sequential-entrance>
                        </ul>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <sequential-entrance fromTop delay="70">
                                <li v-for="input_field in input_fields.column_2" :key="input_field.id">
                                  <div class="view-info-wrapper">
                                    <div class="contact-design">
                                        <i v-bind:class="input_field.icon"></i>
                                        <span> {{input_field.labelName}} </span>
                                    </div>
                                    <p> {{input_field.inputValue}} </p>
                                  </div>
                                </li>
                            </sequential-entrance>
                        </ul>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import AdminsService from '../../api-services/admins.service.js'

export default {
  name: 'viewadmin',
  data () {
    return {
      admin: {
        id: null,
        type: null,
        first_name: null,
        last_name: null,
        company_name: null,
        email: null,
        phone: null,
        county: null,
        city: null,
        address: null,
        cui: null,
        nr_reg: null,
        bank: null,
        site: null,
        delegat: null,
        date_corespondenta: null,
        notes: null,
        has_account: null,
        is_transformed_in_contact: null,
        locations: null,
        contacts: null,
        files: null
      },
      mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']
    }
  },
  methods: {
    getAdmin () {
      AdminsService.get(this.$route.params.id)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          this.admin = response.data.data
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          console.log(error)
        })
    }
  },
  computed: {
    input_fields () {
      return {
        column_1: [
          {
            inputName: 'first_name',
            labelName: this.$t('placeholder.nume'),
            inputValue: (this.admin) ? this.admin.first_name : null,
            icon: 'fas fa-signature'
          },
          {
            inputName: 'last_name',
            labelName: this.$t('placeholder.prenume'),
            inputValue: (this.admin) ? this.admin.last_name : null,
            icon: 'fas fa-signature'
          }
        ],
        column_2: [
          {
            inputName: 'email',
            labelName: this.$t('placeholder.email'),
            inputValue: (this.admin) ? this.admin.email : null,
            icon: 'fas fa-envelope'
          },
          {
            inputName: 'phone',
            labelName: this.$t('placeholder.telefon'),
            inputValue: (this.admin) ? this.admin.phone : null,
            icon: 'fas fa-phone'
          }
        ]
      }
    }
  },
  created () {
    this.getAdmin()
  }
}
</script>
